import { createAction } from "redux-actions";
import axios from "axios";
import authHandler from "../../helpers/authHandler";

import { getLang } from "../crossword/selectors";
import { toggleLogin } from "../ui/actions";
import { fetchLevels } from "../levels/actions";
import {
  getPlayerName,
  getPlayerPrizeById,
  getPlayerPrizeIds
} from "./selectors";

export const FETCH = "user/fetch";
export const FETCH_SUCCESS = "user/fetch_success";
export const FETCH_FAILURE = "user/fetch_failure";

export const DESTROY = "user/destroy";
export const DESTROY_SUCCESS = "user/destroy_success";
export const DESTROY_FAILURE = "user/destroy_failure";

export const ADD_PRIZES = "user/player/prizes/add";
export const SET_PRIZE_POS = "user/player/prize/pos/set";
export const SET_PIRATE_POS = "user/player/pirate/pos/set";

export const fetchStart = createAction(FETCH);
export const fetchSuccess = createAction(FETCH_SUCCESS);
export const fetchFailure = createAction(FETCH_FAILURE);

export const destroyStart = createAction(DESTROY);
export const destroySuccess = createAction(DESTROY_SUCCESS);
export const destroyFailure = createAction(DESTROY_FAILURE);

export const addPrizesToPlayer = createAction(ADD_PRIZES);
export const setPlayerPrizePos = createAction(SET_PRIZE_POS);
export const setPlayerPiratePos = createAction(SET_PIRATE_POS);

export const authenticate = uri => dispatch =>
  authHandler(uri)
    .then(() => dispatch(toggleLogin(false)))
    .then(() => dispatch(fetchUserSession()));

export const fetchUserSession = () => dispatch => {
  dispatch(fetchStart());

  return axios
    .get("/api/session")
    .then(({ data }) => dispatch(fetchSuccess(data)))
    .catch(err => dispatch(fetchFailure(err)));
};

export const destroyUserSession = () => dispatch => {
  dispatch(destroyStart());

  return axios
    .get("/api/logout")
    .then(({ data }) => dispatch(destroySuccess(data)))
    .catch(err => dispatch(destroyFailure(err)));
};

export const addPlayer = playerName => dispatch => {
  return axios
    .post(`/api/player/${playerName}`)
    .then(() => dispatch(setActivePlayer(playerName)))
    .then(() => dispatch(fetchUserSession()));
};

export const removePlayer = playerName => dispatch => {
  return axios
    .delete(`/api/player/${playerName}`)
    .then(() => dispatch(fetchUserSession()));
};

export const setActivePlayer = playerName => dispatch => {
  return axios
    .patch("/api/user", { activePlayer: playerName })
    .then(() => dispatch(fetchUserSession()));
};

export const setPlayerPrizePositions = () => (dispatch, getState) => {
  const state = getState();
  const playerName = getPlayerName(state);
  const prizes = getPlayerPrizeIds(state).map(id => ({
    id,
    pos: getPlayerPrizeById(state, id).pos
  }));

  return axios.patch(`/api/player/${playerName}`, { prizes });
};

export const getPaymentStatus = token => (dispatch, getState) => {
  dispatch(fetchStart());

  return axios
    .post("/api/payment", token)
    .then(() =>
      Promise.all([
        dispatch(fetchUserSession()),
        dispatch(fetchLevels(getLang(getState())))
      ])
    );
};



// WEBPACK FOOTER //
// ./src/reducers/user/actions.js